import { Button, ModalBox, Division } from '@fourthwall/components';
import React from 'react';
export const SendMessageConfirmModal = ({ vm, onConfirmClick, close, }) => (React.createElement(ModalBox, { title: `This message will be sent to ${vm.count || ''} supporters`, buttons: [
        React.createElement(Button, { label: "Cancel", appearance: "secondary", onClick: close }),
        React.createElement(Button, { label: "Send", appearance: "primary", onClick: onConfirmClick }),
    ], onClose: close },
    React.createElement(Division, { size: "small" }, "This action cannot be reversed.")));
